import InputAutocompleteOption from './input_autocomplete_option';

const Realize = {
	InputAutocompleteList: window.InputAutocompleteList,
};

export default class InputAutocompleteList extends Realize.InputAutocompleteList {

	constructor(props) {
		super(props);
		this.renderOptions = InputAutocompleteList.prototype.renderOptions.bind(this);
	}

	renderOptions() {
		var options = [].concat(this.onTopSelectedOptions(), this.otherOptions());
		var listOptions = [];

		for(var i = 0; i < options.length; i++) {
			var optionProps = options[i];
			listOptions.push(
				<InputAutocompleteOption {...optionProps}
				onSelect={this.props.onSelect}
				onOptionMouseEnter={this.props.onOptionMouseEnter}
				position={i}
				isActive={i == this.props.active}
				id={this.props.id}
				key={optionProps.name + i}
				ref={"option_" + i}
				/>
			);
		}

		return listOptions;
	}
}
